import { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Select from "react-select";
import SearchIcon from "@mui/icons-material/Search";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Modal, IconButton, Box, Tooltip, Backdrop, CircularProgress } from '@mui/material';
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import moment from 'moment-timezone';
import swal from 'sweetalert';
import Loader from 'layouts/nbn/components/loader';

const SERVER_URL = process.env.REACT_APP_API_URL;

function RaiseWorkPlanDeviationRequest() {
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [plan, setPlan] = useState({ date: "" });
    const [weekDays, setWeekDays] = useState([]);
    const [selectedDay, setSelectedDay] = useState("");
    const [selectedPlans, setSelectedPlans] = useState([
        { plan: '', selectedDays: [] }
    ]);
    const [searchISLoading, setSearchIsLoading] = useState(false)
    const [storeOptions, setStoreOptions] = useState([{ options: [] }]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedDayIndex, setSelectedDayIndex] = useState(null);
    const [setLoad, setLoading] = useState(false);
    const [selectedStores, setSelectedStores] = useState({});
    const [activityNotes, setActivityNotes] = useState("");


    const [formData, setFormData] = useState({
        retailer_code: "",
        store_name: "",
        email: "",
        abn: "",
        state: "",
        city: "",
        postcode: "",
        street_name: "",
    });

    const getWeekOptions = () => {
        const options = [];
        const currentDate = new Date();

        const currentDay = currentDate.getDay();
        const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;
        currentDate.setDate(currentDate.getDate() + daysUntilMonday);

        for (let i = 0; i < 4; i++) {
            const startOfWeek = new Date(currentDate);
            startOfWeek.setDate(currentDate.getDate() + i * 7);

            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 4);

            const weekLabel = `${startOfWeek.toLocaleString("default", { month: "short" })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString("default", { month: "short" })} ${endOfWeek.getDate()}`;
            const weekRange = { start: startOfWeek.toISOString().split("T")[0], end: endOfWeek.toISOString().split("T")[0] };
            options.push(<option key={i} value={JSON.stringify(weekRange)}>{weekLabel}</option>);
        }

        return options;
    };

    const handleWeekChange = (e) => {
        const weekRange = e.target.value;
        if (weekRange === "") {
            // If "Please choose" is selected, reset the week and days
            setSelectedWeek(null);
            setWeekDays([]);
            setSelectedDay(""); // Reset the day selection
            setPlan((prev) => ({ ...prev, date: "" }));
            return;
        }

        const parsedWeek = JSON.parse(weekRange);
        setSelectedWeek(parsedWeek);
        setPlan((prev) => ({ ...prev, date: parsedWeek.start }));

        const startDate = new Date(parsedWeek.start);
        const days = [];

        // Check if the start day is Sunday (0) - if so, shift the start to Monday
        const dayOfWeek = startDate.getDay();

        if (dayOfWeek === 0) {
            // If it's Sunday (0), move the start date to Monday
            startDate.setDate(startDate.getDate() + 1); // Move to the next day (Monday)

            // Now create the days from Monday to Friday
            for (let i = 0; i < 5; i++) {
                const day = new Date(startDate);
                day.setDate(startDate.getDate() + i);
                days.push({
                    date: day.toISOString().split("T")[0],
                    dayName: day.toLocaleString("default", { weekday: "long" }),
                });
            }
        } else {
            // If it's Monday (or any other day), use the regular Monday to Friday schedule
            for (let i = 0; i < 5; i++) {
                const day = new Date(startDate);
                day.setDate(startDate.getDate() + i);
                days.push({
                    date: day.toISOString().split("T")[0],
                    dayName: day.toLocaleString("default", { weekday: "long" }),
                });
            }
        }

        setWeekDays(days);
    };

    const handleDayChange = (e) => {
        setSelectedDay(e.target.value);
        setPlan((prev) => ({ ...prev, date: e.target.value }));
    };

    const handleSelectChange = (selectedOptions, index) => {
        const updatedPlans = [...selectedPlans];
        updatedPlans[index].selectedDays = selectedOptions;
        setSelectedPlans(updatedPlans);
    };

    const handleTextChange = (value, index) => {
        setActivityNotes(value);
    };

    // Modal toggle function
    const handleModalToggle = (index) => {
        setSelectedDayIndex(index);
        setModalOpen(!isModalOpen);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);  // Start loading indicator

        if (!selectedWeek) {
            toast.error("Please select a week before submitting.");
            setLoading(false);
            return;
        }

        // Input validation
        if (
            formData.retailer_code === "" &&
            formData.store_name === "" &&
            formData.email === "" &&
            formData.abn === "" &&
            formData.state === "" &&
            formData.city === "" &&
            formData.postcode === "" &&
            formData.street_name === ""
        ) {
            toast.error("At least one input field must be filled");
            setLoading(false);  // Stop loading
            return;
        } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter post code or city name");
            setLoading(false);  // Stop loading
            return;
        } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter street name or post code");
            setLoading(false);  // Stop loading
            return;
        }

        const headers = await getApiHeader();
        const filteredFormData = Object.fromEntries(
            Object.entries(formData).filter(([key, value]) => value !== "")
        );

        try {
            const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
                headers: headers
            });

            // Check for a successful response
            if (response.status === 200 && response.data?.data) {
                const options = response.data.data.map((value) => ({
                    label: value.retailer_company_name,
                    value: value.retailer_id,
                }));

                const updatedStoreOptions = weekDays.map((day) => ({
                    ...day,
                    options: options,
                }));

                setStoreOptions(updatedStoreOptions);
                setModalOpen(false);
                // setSearchIsLoading(false);
                setLoading(false);

                if (options.length === 0) {
                    toast.error("No Shop details Found.");
                    // swal({
                    //     title: "Error",
                    //     text: 'No shop details found.',
                    //     icon: "error",
                    //     button: "Close",
                    // });
                  } else {
                    toast.success("Shop details are populated.");
                    // swal({
                    //     title: "Success",
                    //     text: 'Shop details found.',
                    //     icon: "success",
                    //     button: "Close",
                    // });
                  }
            } else {
                // Handle unexpected API responses, even if status is 200 but no data
                setLoading(false);
                const errorMessage = error.response.data?.message || "An unexpected error occurred.";
                swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    button: "Close",
                });
            }
        } catch (error) {
            // Handle any errors that occur during the API request
            // setSearchIsLoading(false);  // Stop loading on error
            setLoading(false);
            console.error("API Error:", error);

            // Show error message based on the error response
            if (error.response) {

                const errorMessage = error.response.data?.message || "An unexpected error occurred.";
                swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    button: "Close",
                });
                // toast.error(errorMessage);
            } else {

                swal({
                    title: "Error",
                    text: "Network error. Please try again.",
                    icon: "error",
                    button: "Close",
                });
            }
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };




    const handleWorkSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Check if selectedWeek is valid before proceeding
        if (!selectedWeek || !selectedWeek.start || !selectedWeek.end) {
            swal({
                title: "Error",
                text: "Please select a valid week.",
                icon: "error",
                button: "Close",
            });
            setLoading(false);
            return;
        }

        // Check if selectedDay is selected
        if (!selectedDay) {
            swal({
                title: "Error",
                text: "Please select a valid day.",
                icon: "error",
                button: "Close",
            });
            setLoading(false);
            return;
        }

        const result = await swal({
            title: "Are you sure?",
            text: "Do you want to submit the work plan deviation?",
            icon: "warning",
            buttons: {
                confirm: {
                    text: 'Yes, submit it',
                    className: 'btn-confirm',
                },
                cancel: {
                    text: 'No, cancel',
                    visible: true,
                    className: 'btn-cancel',
                },
            },
            dangerMode: true,

        });

        // If the user clicked "Submit", proceed with the form submission
        if (result) {
            setSearchIsLoading(true);

            // Prepare the payload without activityNotes and stores
            const payload = {
                work_week_start_date: selectedWeek.start,
                work_week_end_date: selectedWeek.end,
                date: selectedDay,
                activity_notes: activityNotes, // Include activity notes
                stores: selectedPlans.flatMap((day) => day.selectedDays.map((store) => store.value)), // Include stores
            };

            const headers = await getApiHeader();

            try {
                // Send the payload to the API
                const response = await axios.post(`${SERVER_URL}work-plan/create-work-plan-deviation-request`, payload, {
                    headers: headers
                });

                if (response.status === 200) {
                    const successMessage = response.data?.message || "Daily Work plan submitted successfully!";
                    swal({
                        title: "Success",
                        text: successMessage,
                        icon: "success",
                        button: "Close",
                    }).then(() => {
                        window.location.href = '/create_work_plan_deviation'; // Redirect after success
                    });

                    setTimeout(() => {
                        window.location.reload();  // Reload the page after 3 seconds
                    }, 3000);
                    setLoading(false);
                } else {
                    const errorMessage = response.data?.message || "An unexpected error occurred.";
                    swal({
                        title: "Error",
                        text: errorMessage,
                        icon: "error",
                        button: "Close",
                    });

                    // setTimeout(() => {
                    //     window.location.reload();  // Reload the page after 3 seconds
                    // }, 3000);
                    setLoading(false);
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
                swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    button: "Close",
                });
                setLoading(false);
            }
        } else {
            // Reset loading when user clicks cancel on SweetAlert
            setLoading(false);
        }
    };



    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="container">
                {setLoad ? (
                    <Backdrop
                        open={true}
                        style={{
                            color: '#fff',
                            zIndex: 9999,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress
                            color="inherit"
                            style={{
                                display: 'block',
                                '@media (max-width: 999px)': {
                                    display: 'block', // Show loader on mobile
                                }
                            }}
                        />
                    </Backdrop>


                ) : (
                    <form className="workplanform col-lg-10" onSubmit={handleWorkSubmit}>
                        <h4>Create Work Plan Deviation Request</h4>
                        <div className="row">
                            <div className="form-group col-lg-6">
                                <label htmlFor="work-week" className="label">Select the Week:</label>
                                <select id="work-week" name="work-week" className="select" onChange={handleWeekChange} value={selectedWeek ? JSON.stringify(selectedWeek) : ""}>
                                    <option value="">Please choose an option</option>
                                    {getWeekOptions()} {/* Assuming you have a function to generate week options */}
                                </select>
                            </div>

                            <div className="form-group col-lg-6">
                                <label htmlFor="work-day" className="label">Select the Day:</label>
                                <select id="work-day" name="work-day" className="select" onChange={handleDayChange} value={selectedDay}>
                                    <option value="">Please choose an option</option>
                                    {weekDays.map((day, index) => (
                                        <option key={index} value={day.date}>{day.dayName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row align-items-center mb-3">
                            <label htmlFor="plan-details" className="label col-12">
                                Add Work Plan Details
                            </label>
                            {selectedPlans.map((day, index) => (
                                <div className="row mb-4" key={index}>
                                    <div className="col-md-8">
                                        <Select
                                            isMulti
                                            options={storeOptions[index]?.options || []}
                                            value={day.selectedDays}
                                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                            placeholder="Search and add store for revisits"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderRadius: "5px",
                                                    padding: "5px",
                                                }),
                                                multiValue: (provided) => ({
                                                    ...provided,
                                                    backgroundColor: "#c11d6c",
                                                    color: "white",
                                                    padding: "1px",
                                                }),
                                                multiValueLabel: (provided) => ({
                                                    ...provided,
                                                    color: "white",
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-1">
                                        <Tooltip title="Search details of stores" placement="bottom-end">
                                            <IconButton
                                                onClick={() => handleModalToggle(index)} // assuming this opens a modal for store details
                                                aria-label="search"
                                                style={{ marginLeft: "10px", transition: "transform 0.2s" }}
                                                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                            >
                                                <SearchIcon
                                                    sx={{
                                                        color: "#e20e75",
                                                        transition: "transform 0.2s, color 0.2s",
                                                        "&:hover": {
                                                            transform: "scale(1.2)",
                                                            color: "#d50b66",
                                                        },
                                                    }}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    </div>

                                </div>
                            ))}
                            <div className="col-md-12 mt-3">
                                <ReactQuill
                                    value={activityNotes || ''}
                                    onChange={handleTextChange}
                                    placeholder="please provide if any deviations in your planned activities, such as changes in new shop visits, shop revisits and other relevant tasks."
                                    modules={{
                                        toolbar: [
                                            [{ header: [1, 2, false] }],
                                            ["bold", "italic", "underline", "strike", "blockquote"],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                            ["link"],
                                            ["clean"],
                                        ],
                                    }}
                                    style={{ borderColor: "#e20e75", borderRadius: "5px", height: "150px", marginBottom: "55px" }}
                                />
                            </div>

                        </div>
                        <button type="submit" className="submit-button">Submit</button>
                    </form>
                )}
            </div>


            <Modal open={isModalOpen} onClose={handleModalToggle}>

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 600,
                        bgcolor: 'background.paper',
                        //  boxShadow: 24,
                        //  p: 4,
                        borderRadius: 2,
                        '@media (max-width: 950px)': {
                            maxHeight: '90%',
                            overflowY: 'auto',
                        },
                        '@media (max-width: 740px)': {
                            maxHeight: '90%',
                            overflowY: 'auto',
                        },
                        '@media (max-width: 480px)': {
                            width: '350px', // For very small screens (e.g., 350px)
                            maxHeight: '90%',
                            overflowY: 'auto',
                        },
                    }}
                >

                    {/* Close Button */}
                    {!setLoad && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'transparent',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: 'black',
                            }}
                            onClick={handleModalToggle} // This will close the modal
                        >
                            &times; {/* This is the "×" symbol */}
                        </button>
                    )}


                    {setLoad ? (
                        <Backdrop
                            open={true}
                            style={{
                                color: '#fff',
                                zIndex: 9999,
                            }}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>


                    ) : (
                        <form action="" method="" onSubmit={handleSubmit} autoComplete="off">
                            <div className="formbold-mb-5 formbold-pt-3" style={{ marginLeft: "10px", marginRight: "10px" }}>
                                <label className="formbold-form-label formbold-form-label-2">
                                </label>
                                <div className="flex flex-wrap formbold--mx-3">
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Store Name
                                        </label>
                                        <div className="formbold-mb-5">
                                            <input
                                                type="text"
                                                name="store_name"
                                                id="store_name"
                                                placeholder="Enter Store Name"
                                                className="form-control"
                                                value={formData.store_name}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Email  Address
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                placeholder="Enter Email Address"
                                                className="form-control"
                                                value={formData.email}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Retailer ID
                                            </label>
                                            <input
                                                type="text"
                                                name="retailer_code"
                                                id="retailer_code"
                                                placeholder="Enter Retailer ID"
                                                className="form-control"
                                                value={formData.retailer_code}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                ABN
                                            </label>
                                            <input
                                                type="text"
                                                name="abn"
                                                id="abn"
                                                placeholder="Enter ABN"
                                                className="form-control"
                                                value={formData.abn}
                                                onChange={handleChange}
                                                maxLength={12}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                City
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                id="city"
                                                placeholder="Enter City Name"
                                                className="form-control"
                                                value={formData.city}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Post Code
                                            </label>
                                            <input
                                                type="text"
                                                name="postcode"
                                                id="postcode"
                                                placeholder="Enter Post Code"
                                                className="form-control"
                                                value={formData.postcode}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Street Name
                                            </label>
                                            <input
                                                type="text"
                                                name="street_name"
                                                id="street_name"
                                                placeholder="Enter Street Name"
                                                className="form-control"
                                                value={formData.street_name}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            State
                                        </label>
                                        <select
                                            className="form-control"
                                            name="state"
                                            id="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select State</option>
                                            <option value="Act">ACT</option>
                                            <option value="NSW">NSW</option>
                                            <option value="NIT">NIT</option>
                                            <option value="QLD">QLD</option>
                                            <option value="SA">SA</option>
                                            <option value="TAS">TAS</option>
                                            <option value="VIC">VIC</option>
                                            <option value="WA">WA</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            <div className="search-store-buttons">
                                <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>

                            </div>
                        </form>
                    )}
                </Box>
            </Modal>

        </DashboardLayout>
    );
}

export default RaiseWorkPlanDeviationRequest;